import { mapModes } from 'client/utils/constants/appStates';
const { DRAWING, MODIFYING, AOI } = mapModes;

export const VALID_MODES = [
    [AOI, MODIFYING],
    [AOI, MODIFYING, DRAWING]
];
